import React from "react";
import { motion } from "framer-motion";
import { AiFillLayout,AiFillApi, AiFillIeCircle } from "react-icons/ai";

const Services = () => {
  return (
    <div id="services">
      <h2>Services</h2>
      <section>
        <motion.div className="servicesBox1">
          <h3>Fresher:</h3>
          <p> with a lot of projects experince</p>
        </motion.div>
        <motion.div className="servicesBox2">
          <AiFillLayout />
          <span>Frontend Development</span>
        </motion.div>
        <motion.div className="servicesBox3">
          <AiFillApi />
          <span>Backend Development</span>
        </motion.div>
        <motion.div className="servicesBox4">
          <AiFillIeCircle />
          <span>Web Development</span>
        </motion.div>
      </section>
    </div>
  );
};

export default Services;
